import gf1 from '../assets/Images/GreenFood/GF1.png'
import gf2 from '../assets/Images/GreenFood/GF2.png'
import gf3 from '../assets/Images/GreenFood/GF3.png'
import gf4 from '../assets/Images/GreenFood/GF4.png'
import gf5 from '../assets/Images/GreenFood/GF5.png'
import gf6 from '../assets/Images/GreenFood/GF6.png'
import kl1 from '../assets/Images/KuriLabo/KL1.png'
import kl2 from '../assets/Images/KuriLabo/KL2.png'
import kl3 from '../assets/Images/KuriLabo/KL3.png'
import kl4 from '../assets/Images/KuriLabo/KL4.png'
import kl5 from '../assets/Images/KuriLabo/KL5.png'
import kl6 from '../assets/Images/KuriLabo/KL6.png'

export const ProjectGalleries = {
  1: {
    title: 'KuriLabo',
    accent: '#4FC9FF',
    label: 'MOBILE PRODUCT TOUR',
    images: [kl1, kl2, kl3, kl4, kl5, kl6],
  },
  4: {
    title: 'Green Food',
    accent: '#C9A6FF',
    label: 'APP SCREEN TOUR',
    images: [gf1, gf2, gf3, gf4, gf5, gf6],
  },
}
